/**
 * Table paginate config for pagination.
 * 
 * @var const paginateConfig
 */
export const paginateConfig = {
    items: 0, pages: 0,
    pageSize: 10, pageNumber: 1,
    pageSizes: [10, 20, 30, 40, 50],
};